export const NO_DATA_MESSAGE = 'No data';

export const BOOLEAN_TABLE_CELL_CONTENT = 'Yes';

export const OTHER_BOOLEAN_HOSPITAL_TABLE_KEYS = ['pictureArchiving', 'radiologicalInformationSystem'];

export const PHONE_KEY = 'phone';
